<template>
  <m-dialog ref="dlg" @save="save" :title="isEdit ? 'Edit Pemantau' : 'Tambah Pemantau'">
    <v-form @submit.prevent data-vv-scope="form" lazy-validation>
      <span class="title primary--text my-2">Identitas Diri</span>
      <v-row wrap>
        <v-col cols="12" sm="12" md="10" lg="10" class="py-0">
          <label class="caption mb-2">Surel</label>
          <v-text-field
            dense
            single-line
            outlined
            :disabled="isCheckMail"
            label="Surel*"
            v-model="form.email"
            hint="Masukkan Surel Anggota"
            data-vv-name="email"
            data-vv-as="Surel"
            v-validate="'required|email'"
            :error-messages="errors.collect('form.email')"
            @keydown.enter="checkAkun"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" sm="12">
          <v-btn class="mt-3" depressed color="primary" @click="checkAkun">
            <v-icon left>{{ isCheckMail ? 'mdi-pencil' : 'mdi-magnify' }}</v-icon>
            {{ isCheckMail ? 'Ubah Email' : 'Cek Email' }}
          </v-btn>
        </v-col>

        <template v-if="isCheckMail || isEdit">
          <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
            <label class="caption mb-2">Nama Lengkap</label>
            <v-text-field
              autofocus
              dense
              single-line
              outlined
              label="Nama lengkap*"
              v-model="form.nama"
              hint="Masukkan Nama Lengkap"
              data-vv-name="nama"
              data-vv-as="Nama Lengkap"
              v-validate="'required'"
              :error-messages="errors.collect('form.nama')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
            <label class="caption mb-2">Nomor Telp</label>
            <v-text-field
              dense
              single-line
              outlined
              label="Nomor Telp"
              v-model="form.no_hp"
              hint="Masukkan Nomor Telepon"
              data-vv-name="no_hp"
              data-vv-as="Nomor Telp"
              v-validate="'numeric|min:6|max:14'"
              :error-messages="errors.collect('form.no_hp')"
              :autocomplete="false"
            ></v-text-field>
          </v-col>
          <v-col v-if="!isEdit" cols="12" sm="12" md="6" lg="6" class="py-0">
            <label class="caption mb-2">Password</label>
            <v-text-field
              dense
              single-line
              outlined
              label="Password"
              v-model="form.password"
              hint="Masukkan Password"
              data-vv-name="password"
              data-vv-as="Password"
              :type="showPassword ? '' : 'password'"
              v-validate="'required|min:6'"
              :error-messages="errors.collect('form.password')"
              :autocomplete="false"
            >
              <template v-slot:append>
                <v-btn class="mt-n1" icon @click="showPassword = !showPassword">
                  <v-icon>{{ !showPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </template>
      </v-row>
    </v-form>

    <div class="mt-5" v-if="isCheckMail || isEdit">
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="title primary--text">Daftar Organisasi</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="onAdd"><v-icon left>mdi-plus</v-icon> Tambah Organisasi</v-btn>
      </v-toolbar>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Nama
              </th>
              <th class="text-left">
                Kode Organisasi
              </th>
              <th class="text-left">
                Aksi
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in organisasi" :key="item.name">
              <td>{{ item.nama }}</td>
              <td>{{ item.no_reg || item.kode_organisasi }}</td>
              <td>
                <v-btn color="red" text icon @click="onDelete(i)"><v-icon>mdi-delete</v-icon></v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <SelectInstansi ref="select" />
  </m-dialog>
</template>
<script>
export default {
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    SelectInstansi: () => import('./SelectInstansi'),
  },
  data() {
    return {
      form: {},
      organisasi: [],
      isEdit: false,
      isCheckMail: false,
      showPassword: false,
    }
  },
  methods: {
    open({ user, organisasi }) {
      this.reset()

      if (user && organisasi) {
        this.form = user
        this.organisasi = organisasi
        this.isEdit = true
        this.isCheckMail = true
      }
      this.$refs.dlg.open()
    },
    reset() {
      this.$validator.reset()
      this.isEdit = false
      this.form = {}
      this.organisasi = []
      this.isCheckMail = false
      this.showPassword = false
    },
    onAdd() {
      this.$refs.select.open().then((res) => {
        const findIndex = this.organisasi.findIndex((s) => s.organisasi_id === res.organisasi_id)
        this.$refs.select.close()
        if (findIndex > -1) {
          this.$error('Instansi sudah ditambahkan sebelumnya')
        } else {
          this.organisasi.push(res)
        }
      })
    },
    save() {
      const params = this.form
      const payload = this.organisasi.map((s) => s.organisasi_id)

      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          if (payload.length === 0) {
            this.$error('Harap pilih penugasan terlebih dahulu')
            return
          }

          this.$store
            .dispatch(`pemantau/${this.isEdit ? 'saveOrganisasi' : 'createUser'}`, {
              id: this.form.user_id || null,
              params: Object.assign({}, params, { ids: payload }),
            })
            .then(() => {
              this.$success('Aksi berhasil dilakukan')
              this.$emit('reload')
              this.$refs.dlg.dialog = false
            })
            .catch((err) => {
              this.$error(err)
            })
        })
    },

    onDelete(index) {
      this.organisasi.splice(index, 1)
    },

    checkAkun() {
      if (this.isCheckMail) {
        this.isCheckMail = false
        this.form.email = ''
        this.isEdit = false
        if (!this.isEdit) {
          this.form = {}
          this.organisasi = []
        }
        return
      }

      const email = this.form.email || ''

      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          this.$store
            .dispatch('pemantau/cekAkun', email)
            .then(({ data }) => {
              const item = (data && data.data) || {}
              const models = ['nama', 'no_hp', 'user_id']

              models.forEach((key) => {
                this.$set(this.form, key, item[key] || '')
              })

              this.isEdit = !!Object.keys(item).length;
            })
            .then(() => {
              this.isCheckMail = true

              if (this.form && this.form.user_id) {
                this.$store.dispatch('pemantau/getDetail', { id: this.form.user_id }).then(({ data }) => {
                  this.organisasi = (data && data.organisasi) || []
                })
              }
            })
        })
    },
  },
}
</script>
